import React from 'react';
import { Link } from 'react-router-dom';

function Homepage_Pricing() {
  const plans = [
    {
      name: "BASIC",
      price: 499,
      hourlyRate: 8.32,
      hours: 60,
      features: [
        "60 hours of expert VA assistance",
        "Dedicated Project Manager",
        "Communication via Slack",
        "Ideal for small businesses and entrepreneurs",
        "No long-term commitment required",
        "Quality work at less than $9/hour"
      ]
    },
    {
      name: "PRO",
      price: 899,
      hourlyRate: 7.49,
      hours: 120,
      features: [
        "120 hours of premium VA support",
        "Priority task assignment",
        "Dedicated Project Manager",
        "Communication via Slack",
        "Expanded skill set access (e.g., graphic design, content writing)",
        "Perfect for growing businesses and busy professionals",
        "Boost your productivity at just $7.49/hour"
      ]
    },
    {
      name: "ELITE",
      price: 1080,
      hourlyRate: 6,
      hours: 180,
      features: [
        "180 hours of comprehensive VA coverage",
        "24/7 support availability",
        "Multiple Project Managers for complex needs",
        "Full access to all VA specializations",
        "Tailored solutions for large-scale operations",
        "Maximize efficiency at only $6/hour"
      ]
    }
  ];

  return (
    <section id="pricing-section" className="pricing py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div key={index} className={`bg-white overflow-hidden shadow-lg rounded-lg border-2 ${plan.name === 'PRO' ? 'border-purple-500' : 'border-gray-200'}`}>
              <div className="px-6 py-8">
                <h3 className="text-3xl font-bold text-center mb-4">{plan.name}</h3>
                <div className="text-5xl font-bold text-center mb-2">${plan.hourlyRate}/HR</div>
                <div className="text-xl text-gray-600 text-center mb-6">${plan.price}/MTH</div>
                <ul className="space-y-2 mb-8">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-purple-500 mr-2 text-lg">•</span>
                      <span className="text-gray-600 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="border-t border-gray-200 pt-4 mb-8">
                  <ul className="space-y-2">
                    <li className="text-sm text-gray-600 flex items-center">
                      <span className="text-purple-500 mr-2 text-lg">•</span>
                      No hidden fees
                    </li>
                    <li className="text-sm text-gray-600 flex items-center">
                      <span className="text-purple-500 mr-2 text-lg">•</span>
                      Cancel anytime
                    </li>
                    <li className="text-sm text-gray-600 flex items-center">
                      <span className="text-purple-500 mr-2 text-lg">•</span>
                      Secure and confidential service
                    </li>
                  </ul>
                </div>
                <Link
                  to={{
                    pathname: "/checkout",
                    state: { plan: plan }
                  }}
                  className={`block w-full text-center py-3 px-4 rounded-md font-semibold ${
                    plan.name === 'PRO' 
                      ? 'bg-purple-600 text-white hover:bg-purple-700' 
                      : 'bg-white text-black border-2 border-black hover:bg-gray-100'
                  }`}
                >
                  SELECT PLAN
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Homepage_Pricing;